import { Row } from '@tanstack/react-table';
import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import PencilSquareIcon from 'assets/images/icons/pencil-square.svg?react';
import DuplicateIcon from 'assets/images/icons/duplicate.svg?react';
import Button from 'components/button/Button';
import Tooltip from 'components/tooltip/Tooltip';
import { Trigger } from 'models/automation/Triggers';
import useDeleteTriggerModal from '../../modal/useDeleteTriggerModal';

const ActionsCell = ({ row }: { row: Row<Trigger> }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openDeleteTriggerModal } = useDeleteTriggerModal();

  return (
    <>
      <Tooltip id="row-edit-trigger-button" text={t('common.edit')}>
        <Button
          bsStyle="link"
          data-testid="row-edit-trigger-button"
          onClick={() => navigate(`./${row.original.uid}`)}
        >
          <PencilSquareIcon aria-label={t('common.edit')} />
        </Button>
      </Tooltip>

      <Tooltip id="row-duplicate-trigger-button" text={t('common.duplicate')}>
        <Button
          bsStyle="link"
          data-testid="row-duplicate-trigger-button"
          onClick={() =>
            navigate('./duplicate', {
              state: { trigger: row.original },
            })
          }
        >
          <DuplicateIcon aria-label={t('common.duplicate')} />
        </Button>
      </Tooltip>

      <Tooltip id="row-delete-trigger-button" text={t('common.delete')}>
        <Button
          bsStyle="link"
          data-testid="row-delete-trigger-button"
          onClick={() => openDeleteTriggerModal(row.original)}
        >
          <Glyphicon glyph="trash" aria-label={t('common.delete')} />
        </Button>
      </Tooltip>
    </>
  );
};

export default ActionsCell;
